"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineLogin = void 0;
var axios_1 = __importDefault(require("axios"));
var nookies_1 = require("nookies");
var react_1 = require("react");
var react_router_1 = require("react-router");
var randomString = function (len) {
    var str = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    var strLen = str.length;
    var result = "";
    for (var i = 0; i < len; i++) {
        result += str[Math.floor(Math.random() * strLen)];
    }
    return result;
};
var useLineLogin = function () {
    var randomState = (0, react_1.useState)(randomString(8))[0];
    var _a = (0, react_1.useState)({ baseUrl: "", lineClientId: "" }), lineInfo = _a[0], setLineInfo = _a[1];
    var location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.procedure_url) {
            (0, nookies_1.setCookie)(null, "procedure_url", (_b = location.state) === null || _b === void 0 ? void 0 : _b.procedure_url, {
                maxAge: 10 * 60,
                path: "/",
            });
        }
        if ((_c = location.state) === null || _c === void 0 ? void 0 : _c.procedure_code) {
            (0, nookies_1.setCookie)(null, "procedure_code", (_d = location.state) === null || _d === void 0 ? void 0 : _d.procedure_code, {
                maxAge: 10 * 60,
                path: "/",
            });
        }
        (0, nookies_1.setCookie)(null, "state", randomState, {
            maxAge: 10 * 60,
            path: "/",
        });
    }, []);
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/line/config").then(function (data) {
            setLineInfo({
                baseUrl: data.data.base_url,
                lineClientId: data.data.client_id,
            });
        });
    }, []);
    return { randomState: randomState, lineInfo: lineInfo };
};
exports.useLineLogin = useLineLogin;
